export default __webpack_public_path__ + "static/media/islam.313febbd.svg";